import NoveltyDividend from '@classic/Betting-v2/Model/NoveltyDividend'

export class NoveltyDividendsViewModel {
  public noveltyDividends: ko.ObservableArray<NoveltyDividend>

  constructor(params: { noveltyDividends: ko.ObservableArray<NoveltyDividend> }) {
    this.noveltyDividends = params.noveltyDividends
  }
}
